<template>
  <q-page padding>
    <q-form
      class="row justify-center"
      @submit.prevent="handleLogin"
    >
      <h5 class="col-12 text-center">Entrar no Só Frases</h5>
      <div class="col-md-4 col-sm-6 col-xs-10  q-gutter-y-md">
        <q-input
          v-model="form.email"
          label="Email"
          type="email"
          lazy-rules
          :rules="[ val => val && val.length > 0 || 'Favor informe um email valido!']"
        >
          <template v-slot:prepend>
            <q-icon name="mail" />
          </template>
        </q-input>
        <q-input
          v-model="form.password"
          label="Senha"
          :type="isPwd ? 'password' : 'text'"
          lazy-rules
          :rules="[ val => val && val.length >= 8 || 'Favor informe uma senha com no mínimo 8 caracteres!']"
        >
          <template v-slot:prepend>
            <q-icon name="lock" />
          </template>
          <template v-slot:append>
            <q-icon
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
        <div class="full-width">
          <a href="/forgot-password">Esqueceu a sua senha?</a>
        </div>
        <div class="full-width q-mt-md">
          <q-btn
            label="Entrar"
            class="full-width"
            color="primary"
            type="submit"
            icon="login"
          />
        </div>
        <div class="full-width">
          <q-btn
            label="Voltar"
            class="full-width"
            flat
            :to="{name: 'home'}"
            icon="arrow_back"
          />
        </div>
        <div class="full-width">
          <p>Não está cadastrado? <a href="/register">Cadastre-se já</a></p>
        </div>
      </div>

    </q-form>

  </q-page>
</template>
<script>
import { defineComponent, ref, onMounted } from 'vue'
import useAuthUser from '../composables/UseAuthUser'
import { useRouter } from 'vue-router'
import useNotify from '../composables/UseNotify'

export default defineComponent({
  name: 'PageLogin',

  setup () {
    const router = useRouter()

    const { login, isLoggedIn } = useAuthUser()

    const { notifyError, notifySuccess } = useNotify()

    const form = ref({
      email: '',
      password: ''
    })

    const isPwd = ref(true)

    const handleLogin = async () => {
      try {
        await login(form.value)
        notifySuccess('Login realizado com sucesso!')
        router.push({ name: 'home' })
      } catch (error) {
        notifyError(error.message)
      }
    }

    onMounted(async () => {
      const _isLoggedIn = await isLoggedIn()
      console.log(_isLoggedIn)
      if (_isLoggedIn) { router.push({ name: 'home' }) }
    })

    return { form, isPwd, handleLogin }
  }
})
</script>
